// This is a temporary service for using AngularJS factories from Angular

angular.
module("dx.webapp.angular").
factory("dxFactoryHelper", function factoryHelperService(
	Node,
	Role,
	Invite,
	DxUser
) {
	"use strict";

	function newNode(nodeData) {
		if (nodeData) {
			return new Node(nodeData);
		}

		return new Node();
	}

	function newRole(roleData) {
		if (roleData) {
			return new Role(roleData);
		}

		return new Role();
	}

	function newInvite(inviteData) {
		if (inviteData) {
			return new Invite(inviteData);
		}

		return new Invite();
	}

	function newDxUser(userData) {
		if (userData) {
			return new DxUser(userData);
		}

		return new DxUser();
	}

	return {
		newNode: newNode,
		newRole: newRole,
		newInvite: newInvite,
		newDxUser: newDxUser,
	};
});
